module.exports = __webpack_public_path__ + "img/inProgress.b36ada1d.svg";